import { Column, FMColumn } from '../model';
import { Type } from '../../../../general/modules/filter/dataModel';
import { FilterDateContainer } from '../components/plugins/filters/FilterDateContainer';
import { DateCell } from '../components/cells/DateCell';

export const updatedCol: FMColumn<Type.DATE> = {
  key: Column.updated_at,
  dataKey: Column.updated_at,
  title: 'Updated at',
  // Было 120: индикатор сортировки, который теперь рисует сама таблица,
  // переносил заголовок на две строки.
  width: 135,
  sortable: true,
  cellRenderer: DateCell,
  className: 'ch-file-manager__cell_updated_at',
  filter: Type.DATE,
  plugins: [FilterDateContainer],
  getter: (row) => new Date(row.updated_at),
  toDisplayString: (row) => new Date(row.updated_at).toDateString(),
};
